<template>
  <el-row :gutter="10">
    <el-col :span="6">
      <left-table />
    </el-col>
    <el-col :span="18">
      <right-table />
    </el-col>
  </el-row>
</template>
<script>
import LeftTable from './components/left-table/index.vue'
import RightTable from './components/right-table/index.vue'
export default {
  name: 'fabricAttributes',
  components: {
    LeftTable,
    RightTable,
  },
}
</script>


<!--<template>
  <div class="card-form">
    <div class="mb-3">
      <page-header
        @loadLeftData="loadLeftData"
        @reset="reset"
        @add="add"
        @submit="handleSubmit"
        slot="header"
        ref="header"
      />
    </div>
    <page-main
      ref="main"
      :leftTableData="leftTableData"
      :leftLoading="leftLoading"
      :loading="loading"
      :table-data="table"
      @leftClick="leftClick"
      @submit="reload"
    />
    <js-pagination
      class="mt-2"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="sm"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
export default {
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      loading: false,
      leftLoading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      leftTableData: []
    }
  },
  methods: {
    add() {
      this.$refs.main.fromLoad('add')
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
      this.$nextTick(() => {
        this.$refs.main.clearSelected()
      })
    },
    reload() {
      this.$refs.header.query()
    },
    leftClick(form) {
      this.$refs.header.assign(form)
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    //加载左侧数据
    loadLeftData() {
      this.leftLoading = true
      this.$api
        .bizDict({ dictType: 'fabricAttributeType' })
        .then((res) => {
          this.leftLoading = false
          this.leftTableData = res.body.data
        })
        .catch(() => {
          this.leftLoading = false
        })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    //加载数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .masterFabricAttributesListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>-->
